export function animationEventData(details){
  if(!['gif','mp4'].includes(details?.format) || !Number.isFinite(details.duration) || !(details.duration>0) || !Number.isFinite(details.bytes) || !(details.bytes>0) || !Number.isInteger(details.frameCount) || details.frameCount<1 || ![.5,1,1.5,2].includes(details.speed))return null;
  return {
    type:'play_animation_export',v:1,
    playName:String(details.playName||'OpenDraw').slice(0,200),format:details.format,
    width:388,height:360,duration:Math.round(details.duration*1000)/1000,
    bytes:details.bytes,frameCount:details.frameCount,
    speed:details.speed,intro:!!details.intro,frameLabel:!!details.frameLabel
  };
}

export async function recordAnimationExport({firebase,uid,playId,...details}){
  const data=animationEventData(details);
  if(!firebase || !uid || !playId || !data)return false;
  if(firebase.auth().currentUser?.uid!==uid)return false;
  try{
    await firebase.firestore().collection('users').doc(uid).collection('animations').add({
      ...data,playId,createdAt:firebase.firestore.FieldValue.serverTimestamp()
    });
    return true;
  }catch(error){console.warn('[animation metrics]',error);return false;}
}

export function summarizeAnimations(events){
  const valid=(events||[]).filter(e=>e.type==='play_animation_export'&&e.uid&&e.playId&&['gif','mp4'].includes(e.format));
  return {
    plays:new Set(valid.map(e=>JSON.stringify([e.uid,e.playId]))).size,
    exports:valid.length,users:new Set(valid.map(e=>e.uid)).size,
    mp4:valid.filter(e=>e.format==='mp4').length,gif:valid.filter(e=>e.format==='gif').length
  };
}
